import moment from 'moment';

const CUSTOM_LOCALE = 'es-PR';
const EN_US_LOCALE = 'en-US';

export const date = (value) => {
  if (!value) return '-';
  return moment(value)
    .locale(CUSTOM_LOCALE)
    .format('DD/MMM/YYYY')
    .replace(/ 0(?:0)?/, ' ');
};

export const datetime = (value) => {
  if (!value) return '-';
  return moment(value)
    .locale(CUSTOM_LOCALE)
    .format('DD/MMM/YYYY hh:mm a')
    .replace(/ 0(?:0)?/, ' ');
};

export const currency = (value) => {
  if (value === undefined || value === '') return '-';
  return value.toLocaleString(EN_US_LOCALE, { minimumFractionDigits: 0 })
};

export const capitalize = (value) => {
  if (!value) return "";
  value = value.toString();

  return value
    .toLowerCase()
    .split(" ")
    .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
    .join(" ");
};

export const empty = (value) => {
  return !value ? '-' : value;
};
